module.exports = __webpack_public_path__ + "img/illustration-features-tab-2.11b0ec33.svg";